<template>
  <div>
    <el-input v-model="tmp" placeholder="搜索平台订单编号" readonly clearable @focus="eventOthOrderNo"/>
    <el-dialog title="依据平台订单编号查询" :visible.sync="show" width="30%">
      <el-input
          type="textarea"
          placeholder="查询多个平台订单编号，以英文逗号、空格或回车键隔开"
          v-model="oth_order_nos"
          maxlength="5000"
          :autosize="{ minRows: 4, maxRows: 25}"
          show-word-limit
      />
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" icon="el-icon-search" @click="handleDo">查 单</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "SOthOrderNos",
  props: {
    value: {
      type: [String],
      required: false,
    }
  },
  data() {
    return {
      oth_order_nos: '',
      show: false,
      tmp: null,
    }
  },
  watch: {
    tmp(_) {
      this.oth_order_nos = _ ? this.oth_order_nos : ''
      this.$emit('update:value', this.oth_order_nos)
    },
    value(_) {
      this.tmp = _ ? this.tmp : ''
    }
  },
  methods: {
    eventOthOrderNo: function () {
      this.show = true
    },
    handleDo: function () {
      this.show = false
      this.tmp = this.oth_order_nos
    }
  }

}
</script>
<style scoped>

</style>
